export default { sha: 'afe6da057b1599fc4b87d84163c8abed51b61cea', buildNumber: 'undefined' }
